import type { ProcessStepPreset } from './types';
import { mutations as TYPES } from './types';
import type { State } from '@modules/editor-sidebar/store/state';
import type { Preset, PresetOptionType } from '@modules/global-style';
import cloneDeep from 'lodash.clonedeep';
import type { TCategorySidebar, TElementSidebarEditor } from '../types';
import { convertColorOptionToCssObject } from '@/modules/global-style';

const mutations = {
  [TYPES.SET_STEP_PRESET](
    state: State,
    payload: {
      next: ProcessStepPreset;
      prev: ProcessStepPreset;
    },
  ) {
    state.nextPreset = payload.next;
    state.prevPreset = payload.prev;
  },
  [TYPES.COMMIT_PRESETS](state: State, presets: Preset[]) {
    state.presets = presets;
  },
  [TYPES.SET_LOADING_SNIPPETS](state: State, isLoading: boolean) {
    state.isLoadingSnippet = isLoading;
  },
  [TYPES.ADD_NEW_SNIPPETS](state: State, snippet: TElementSidebarEditor) {
    const oldSnippetInCategory = state.newSnippets[snippet.category] || [];
    const isExit = oldSnippetInCategory.find((item) => item.id == snippet.id);
    if (!isExit) {
      state.newSnippets = {
        ...state.newSnippets,
        [snippet.category]: oldSnippetInCategory.concat(snippet),
      };
    }

    state.snippetDeleted[snippet.id] = false;
  },
  [TYPES.DELETE_SNIPPET](state: State, snippetId: string) {
    state.snippetDeleted[snippetId] = true;
  },
  [TYPES.SET_LOADING_PRESETS](state: State, isLoadingPreset: boolean) {
    state.isLoadingPreset = isLoadingPreset;
  },
  [TYPES.SET_SNIPPERS](state: State, snippetCategories: TCategorySidebar[]) {
    state.snippetCategories = snippetCategories;
  },
  [TYPES.COMMIT_PAGES](state: State, pages: any[]) {
    // Vue.set(state, 'pages', pages);
    state.pages = pages;
  },
  [TYPES.SET_CURRENT_PRESET](state: State, preset: Preset) {
    // Vue.set(state, 'currentPreset', cloneDeep(preset));
    state.currentPreset = cloneDeep(preset);
    if (preset?.presetOptions?.colors[0]) {
      const cssObject = convertColorOptionToCssObject(preset.presetOptions.colors[0]);
      const cssStyle = `<style class="gf_gs-global-style-colors" type='text/css'>:root{${Object.values(cssObject).join(
        '',
      )}}</style>`;
      state.variablesColorStyle = cssStyle;
      // Vue.set(state, 'variablesColorStyle', cssStyle);
    }
  },
  [TYPES.SET_CURRENT_PRESET_IN_PAGE](state: State, preset: Preset) {
    // Vue.set(state, 'currentPresetInPage', cloneDeep(preset));
    state.currentPresetInPage = cloneDeep(preset);
    if (preset?.presetOptions?.colors[0]) {
      const cssObject = convertColorOptionToCssObject(preset.presetOptions.colors[0]);
      const cssStyle = `<style class="gf_gs-global-style-colors" type='text/css'>:root{${Object.values(cssObject).join(
        '',
      )}}</style>`;
      // Vue.set(state, 'variablesColorStylePresetInPage', cssStyle);
      state.variablesColorStylePresetInPage = cssStyle;
    }
  },
  [TYPES.SET_PRESET_TYPE_ID](state: State, type: PresetOptionType) {
    // Vue.set(state, 'currentPresetOptionType', type);
    state.currentPresetOptionType = type;
  },
  [TYPES.PRESET_MODAL](state: State, value: boolean) {
    state.presetModal = value;
  },
  [TYPES.PRESET_MODAL_NOTIFY](state: State, value: string) {
    state.presetModalNotify = value;
  },
  [TYPES.RELOAD_PAGE_FONTS](state: State, pageFonts: []) {
    state.fontManager = pageFonts;
  },
  [TYPES.SET_CURRENT_PRESET_OPTIONS](state: State, presetOptions: any[]) {
    state.currentPresetOptions = cloneDeep(presetOptions);
  },
  [TYPES.SET_PERSET_TO_PRESET_LIST](state: State, preset: Preset): void {
    const index = state.presets.findIndex((item) => item.id === preset.id);
    if (index != -1) {
      state.presets[index] = { ...state.presets[index], ...preset };
      state.presets = [...state.presets];
    }
  },
  [TYPES.RELOAD_PAGE_FONTS](state: State, pageFonts: []) {
    state.fontManager = pageFonts;
  },
  [TYPES.SET_PREVIEW_PRESET](state: State, preview: boolean) {
    state.previewPreset = preview;
  },
  [TYPES.SET_LINKED_PRESET_ID](state: State, presetId: any) {
    state.linkedPresetId = presetId;
  },
  [TYPES.SET_OLD_LINKED_PRESET_ID](state: State, presetId: any) {
    state.oldLinkedPresetId = presetId;
  },
  [TYPES.CHANGE_ACTIVE_TAB](state: State, tab: any) {
    for (let index = 0; index < state.tabs.length; index++) {
      const item = state.tabs[index];
      const val = item.key === tab.key;
      if (val != item.isActive) {
        state.tabs[index].isActive = val;
      }
    }
  },
  [TYPES.SET_VIEW_TARGET_PRESET](state: State, viewTarget: any) {
    state.viewTargetPreset = viewTarget;
  },
  [TYPES.SET_COMPONENT_TARGET_GLOBAL_STYLE](state: State, component: any) {
    state.componentTargetGlobalStyle = component;
  },
  [TYPES.SET_STYLE_ID_TARGET_GLOBAL_STYLE](state: State, id: any) {
    state.styleIdTargetGlobalStyle = id;
  },
  [TYPES.SET_IS_CALLING_API](state: State, payload: boolean) {
    state.isCallingApi = payload;
  },
  [TYPES.SET_IS_OPEN_SETTING](state: State, payload: boolean) {
    state.isOpenSetting = payload;
  },
  [TYPES.SET_APPLIED_GS_FOR_PAGE](state: State, payload: boolean) {
    state.isAppliedGsForPage = payload;
  },
  [TYPES.SET_IS_PUBLISH_PRESET](state: State, payload: boolean) {
    state.isPublishPreset = payload;
  },
  [TYPES.SET_SIDE_BAR_SETTING_ELEMENT_ID](state: State, payload: any) {
    state.sideBarElement = payload;
  },
  [TYPES.UPDATE_ELEMENT_SETTING_ACTIVE](state: State, payload: string) {
    state.elementKeySettingActive = payload;
  },
};

export default mutations;
